import { API, Auth, Hub, Cache } from "aws-amplify";
import axios from 'axios';
import React, { Component } from "react";
import { Button, Col, Form, Nav, Navbar, NavDropdown, Row } from "react-bootstrap";
import { configure, HotKeys } from "react-hotkeys";
import { LinkContainer } from "react-router-bootstrap";
import { withRouter } from "react-router-dom";
import Creatable from 'react-select/creatable';
import "./App.css";
import './containers/common/Detail.css';
import Routes from "./Routes";
import config from "./config";



const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const keyMap = {
    QUICK_LOOKUP: "alt+l"

  };
  configure({ignoreTags: []});  
  
class App extends Component {
    constructor(props) {
        super(props);
        this.listener = this.listener.bind(this);
        this.handleSelectCityScope = this.handleSelectCityScope.bind(this);
        this.handleSelectSLM = this.handleSelectSLM.bind(this);
        this.handleSelectCoapiDemo = this.handleSelectCoapiDemo.bind(this);
        this.handleAppReset =this.handleAppReset.bind(this);
        this.renderCityscope = this.renderCityscope.bind(this);
        this.renderSLM = this.renderSLM.bind(this);
        this.renderCoapiDemo = this.renderCoapiDemo.bind(this);
        this.focusOnQuickLookup = this.focusOnQuickLookup.bind(this);

        Hub.listen('auth', this.listener);
        
        
        this.state = {
            isAuthenticated: false,
            isAuthenticating: true,
            user: null,
            selectedProperty: null,
            propertyOptions: [],
            propertyKey: "",
            slmlookups: [],
            cityscopelookups: [],
            selectedApp: null,

            //SLM Lookups
            sourcecategoryOptions: [],
            statuscategoryOptions: [],
            spaceusecategoryOptions: [],
            broadspaceusecategoryOptions: [],
            zoningcategoryOptions: [],
            qualitytypecategoryOptions: [],
            titlebasiscategoryOptions: [],
            salemethodcategoryOptions: [],
            saledescribercategoryOptions: [],
            incomebasiscategoryOptions: [],
            areabasiscategoryOptions: [],
            carspacecategoryOptions: [],
            saleTypes: [],
            leasemethodcategoryOptions: [],
            leaseleasestatuscategoryOptions: [],
            leaselevelcategoryOptions: [],
            leaseoutgoingscategoryOptions: [],
            rentperannumbasiscategoryOptions: [],
            rentpersqmbasiscategoryOptions: [],
            leaselreviewbasiscategoryOptions: [],
            leaseTypes: [],
            streetTypes: [],
            unitTypes: [],
            categoryGroups: [],
            liftOperatorOptions: [],
            articleCategories: [],
            fileTypes: [],
            withholdingReasons: [],
            buildingGradeSourceOptions: [],
            buildingGradeOptions: [],
            classificationOptions: [],
            leaseClassificationOptions: [],
            subRegionOptions: [],
            reviewTypeOptions: [],
            countryOptions: [],
            countryCodeOptions: [],
            salutationOptions: [],
            positionOptions: [],
            firstNames: []

        };
    }

    componentWillUnmount() {
        source.cancel();
    }

    async componentDidMount() {
        try {

            console.log("In App.js component did mount");

            
            
            await Auth.currentSession();
            this.userHasAuthenticated(true);
            

            Auth.currentAuthenticatedUser().then(user => {
                console.log("User details in componentDidMount: ");
                console.log(user);
                this.setState(state => ({ user: user.username.replace("ad.corelogic.asia_corelogic-asia\\", "").replace("ISC_", "").replace("@cotality.com", "") }));
                if (this.props.location.pathname==="/"){
                    this.handleAppReset();
                }
                else if(this.props.location.pathname.includes("slm")){
                    this.handleSelectSLM();
                }
                else if(this.props.location.pathname==='/coapidemo') {
                    this.handleSelectCoapiDemo();
                }
                else{
                    this.handleSelectCityScope();
                }
            }).catch(e => {
                console.log(e);

            });
            

        }
        catch (e) { // <-- gets here if no user logged in
            if (e !== 'No current user') { // <-- If it doesnt pop up with no current user then it will go into this
                console.log("inside catch  if e !== No current user");
                console.log(e);
            } else { // <-- so when no one is logged in, it should throw this message
              console.log("threw an error");
              console.log("Inside catch & else statement of componentDidMount and is Authenicating is now = " + this.state.isAuthenticating + " (App.js)");
              this.setState({ isAuthenticating: false }); //<-- delete this and uncomment #1 if doesnt work (3a)
            }
              //console.log(e);
              //console.log("Inside catch of componentDidMount and is Authenicating is now = " + this.state.isAuthenticating + " (App.js)");
              //this.setState({ isAuthenticating: false }); <-- uncomment this for #1 if doesnt work (2a)
              console.log("Inside catch of componentDidMount and is Authenicating is now = " + this.state.isAuthenticating + " (App.js)");

        }
        
        Cache.configure();
        

    }

    //async componentDidUpdate(prevProps, prevState)
    //{
//        if (prevProps.location !== this.props.location) {
//            console.log(this.props.location.pathname);
//            if (this.props.location.pathname==="/"){
//                this.handleAppReset();
//            }
//    }
 //    }
    listener = (data) => {
        const { channel, payload } = data;
        

        if (channel === 'auth') {
            switch (payload.event) {
                case 'signIn':
                    console.log("Auth even: "+ payload.event)
                    this.userHasAuthenticated(true);
                    
                    this.setState({ isAuthenticating: false });
                    Auth.currentAuthenticatedUser().then(user => {                        
                        this.setState({ user: user.username.replace("ad.corelogic.asia_corelogic-asia\\", "").replace("ISC_", "").replace("@cotality.com", "") });
                    }).catch(e => {
                        console.log(e);
                    });
                    Auth.currentCredentials().then(creds => console.log(creds));                    
                    this.props.history.push("/");
                    break;
                case 'signIn_failure':
                    
                    break;
                default:
                    break;
            }


        }
    }

    userHasAuthenticated = authenticated => {
        this.setState({ isAuthenticated: authenticated });

    }

    handleLogin = async event => {
        this.setState({ isAuthenticating: true });
        const config = Auth.configure();
        const { domain, redirectSignIn, redirectSignOut, responseType } = config.oauth
        const clientId = config.userPoolWebClientId;
        const url = 'https://' + domain + '/login?redirect_uri=' + redirectSignIn + '&response_type=' + responseType + '&client_id=' + clientId;

        window.location.assign(url);

    }

    handleLogout = async event => {
        await Auth.signOut();

        this.userHasAuthenticated(false);
        console.log("HandlelogOUT Authenticating changed to = " + this.state.isAuthenticating + " (App.js)")
        this.props.history.push("/");

    }

    getPropertySearchHistory(filter) {
        try {
            console.log("In get user search history");
            console.log(filter);
            API.get("colin", `/propertysearches`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((propertyOptions) => {
                if (propertyOptions) {
                    this.setState(state => ({ propertyOptions }));
                    
                }
            });
        }
        catch{
            console.log("Error getting property search history");
        }
    }
    getUserPermissions(filter) {
        try {
            console.log("In get user permissions");
            console.log(filter);
            API.get("colin", `/users`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((userPermissions) => {
                if (userPermissions) {
                    this.setState(state => ({ userPermissions: userPermissions[0], trust_proof: userPermissions[0].trust_proof }));
                    
                }
            });
        }
        catch{
            console.log("Error getting user permissions");
        }
    }


    synchState()
    {
        if (this.state.cityscopelookups.length>=1){
                
            const liftOperatorOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="lift_operator"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(liftOperatorOptions){
                this.setState({liftOperatorOptions});
            }

            const articleCategories = this.state.cityscopelookups.filter((a) => { if(a.look_up==="article_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(articleCategories){
                this.setState({articleCategories});
            }

            const fileTypes = this.state.cityscopelookups.filter((a) => { if(a.look_up==="file_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(fileTypes){
                this.setState({fileTypes});
            }

            const withholdingReasons = this.state.cityscopelookups.filter((a) => { if(a.look_up==="withholding"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(withholdingReasons){
                this.setState({withholdingReasons});
            }
            

            const buildingGradeSourceOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="building_grade_source"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(buildingGradeSourceOptions){
                this.setState({buildingGradeSourceOptions});
            }

            const buildingGradeOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="building_grade"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(buildingGradeOptions){
                this.setState({buildingGradeOptions});
            }

            const classificationOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="classification"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(classificationOptions){
                this.setState({classificationOptions});
            }

            const leaseClassificationOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="lease_classification"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(leaseClassificationOptions){
                this.setState({leaseClassificationOptions});
            }

            const reviewTypeOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="review_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (reviewTypeOptions) {
                this.setState({ reviewTypeOptions });
            }
            const countryOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="country"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (countryOptions) {
                this.setState({ countryOptions });
            }
            const countryCodeOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="country_codes"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (countryCodeOptions) {
                this.setState({ countryCodeOptions });
            }
            const salutationOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="salutation"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (salutationOptions) {
                this.setState({ salutationOptions });
            }
            const positionOptions = this.state.cityscopelookups.filter((a) => { if(a.look_up==="position"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (positionOptions) {
                this.setState({ positionOptions });
            }
            const firstNames = this.state.cityscopelookups.filter((a) => { if(a.look_up==="first_names"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (firstNames) {
                this.setState({ firstNames });
            }

        }


        if (this.state.slmlookups.length>=1){
                
            const spaceusecategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="space_use"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if(spaceusecategoryOptions){
                this.setState({spaceusecategoryOptions});
            }

            const sourcecategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="source_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (sourcecategoryOptions) {
                this.setState({ sourcecategoryOptions });
            }

            const statuscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_status_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (statuscategoryOptions) {
                this.setState({ statuscategoryOptions });
            }

            const broadspaceusecategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="broad_space_use"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (broadspaceusecategoryOptions) {
                this.setState({ broadspaceusecategoryOptions });
            }
            

            const zoningcategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_zoning_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (zoningcategoryOptions) {
                this.setState({ zoningcategoryOptions });
            }
            
            const qualitytypecategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="quality_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (qualitytypecategoryOptions) {
                this.setState({ qualitytypecategoryOptions });
            }
            
            const titlebasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_title_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (titlebasiscategoryOptions) {
                this.setState({ titlebasiscategoryOptions });
            }
            
            const salemethodcategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_method_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (salemethodcategoryOptions) {
                this.setState({ salemethodcategoryOptions });
            }

            const saledescribercategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_describer_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (saledescribercategoryOptions) {
                this.setState({ saledescribercategoryOptions });
            }
            
            const incomebasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sales_income_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (incomebasiscategoryOptions) {
                this.setState({ incomebasiscategoryOptions });
            }
            
            const areabasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="building_area_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (areabasiscategoryOptions) {
                this.setState({ areabasiscategoryOptions });
            }
            
            const carspacecategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="car_space_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (carspacecategoryOptions) {
                this.setState({ carspacecategoryOptions });
            }

            const saleTypes = this.state.slmlookups.filter((a) => { if(a.look_up==="sale_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (saleTypes) {
                this.setState({ saleTypes });
            }

            const leasemethodcategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_type_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leasemethodcategoryOptions) {
                this.setState({ leasemethodcategoryOptions });
            }
            
            const leasestatuscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_status_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leasestatuscategoryOptions) {
                this.setState({ leasestatuscategoryOptions });
            }

            
            const leaselevelcategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_level_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leaselevelcategoryOptions) {
                this.setState({ leaselevelcategoryOptions });
            }

            const leaseoutgoingscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_outgoings_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leaseoutgoingscategoryOptions) {
                this.setState({ leaseoutgoingscategoryOptions });
            }

            const rentperannumbasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="rent_per_annum_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (rentperannumbasiscategoryOptions) {
                this.setState({ rentperannumbasiscategoryOptions });
            }
            const rentpersqmbasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="rent_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (rentpersqmbasiscategoryOptions) {
                this.setState({ rentpersqmbasiscategoryOptions });
            }

            const leaselreviewbasiscategoryOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_review_basis_category"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leaselreviewbasiscategoryOptions) {
                this.setState({ leaselreviewbasiscategoryOptions });
            }

            const leaseTypes = this.state.slmlookups.filter((a) => { if(a.look_up==="lease_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (leaseTypes) {
                this.setState({ leaseTypes });
            }

            const streetTypes = this.state.slmlookups.filter((a) => { if(a.look_up==="street_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (streetTypes) {
                this.setState({ streetTypes });
            }
            const unitTypes = this.state.slmlookups.filter((a) => { if(a.look_up==="unit_type"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (unitTypes) {
                this.setState({ unitTypes });
            }

            const categoryGroups = this.state.slmlookups.filter((a) => { if(a.look_up==="category_group"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (categoryGroups) {
                this.setState({ categoryGroups });
            }
            
            const subRegionOptions = this.state.slmlookups.filter((a) => { if(a.look_up==="sub_region"){return true;}else{return false;}} ).map(a => a.list)[0]  ;
            if (subRegionOptions) {
                this.setState({ subRegionOptions });
            }

            
            

            
        }
    }

    async getCityscopeLookups(filter) {
        try {
            // console.log("In get cityscope lookups "+filter);
             
            //const lookups = Cache.getItem('slmlookups');
            const cachedCityscopeLookupdate=await Cache.getItem('cityscopelookupdate');
            //await Cache.removeItem('cityscopelookupdate');
            // console.log("Cache date: "+cachedCityscopeLookupdate);

            await API.get("colin", `/cityscopelookups/date`, {  'cancelToken': source.token }).then((cityscopelookupdate) => {
            
                //If a lookup has been updated since the cache was last refreshed, update the cache
                if(new Date(cityscopelookupdate.look_up_date) > new Date(cachedCityscopeLookupdate) || cityscopelookupdate.look_up_date ==null){
                    // console.log("Cache expired or not present getting lookups: "+ cachedCityscopeLookupdate+ " "+ cityscopelookupdate.look_up_date);
                    API.get("colin", `/cityscopelookups`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((cityscopelookups) => {
                        if (cityscopelookups) {
                            var expiration = new Date();
                            expiration.setDate(expiration.getDate()+1);
                            Cache.setItem('cityscopelookupdate', new Date(), { expires: expiration.getTime() });      
                            console.log("retrieved lookups : ");
                            this.setState({ cityscopelookups }, this.synchState);
                            Cache.setItem('cityscopelookups', cityscopelookups);
                            
                            //console.log("expiration: "+expiration);
                                                                      
                        }
                    });
                }
                else
                {
                    // console.log('Retrieving looksups from cache');
                    const cityscopelookups= Cache.getItem('cityscopelookups');
                    this.setState({ cityscopelookups }, this.synchState);
                }

            
        });
        }
        catch{
            console.log("Error getting cityscopelookups");
        }
    }

    async getSLMLookups(filter) {
        try {
            console.log("In get slm lookups "+filter);
             
            //const lookups = Cache.getItem('slmlookups');
            const cachedSlmLookupdate=await Cache.getItem('slmlookupdate');
            //Cache.removeItem('slmlookupdate');
            //console.log("Cache date: "+cachedSlmLookupdate);

            API.get("colin", `/slmlookups/date`, {  'cancelToken': source.token }).then((slmlookupdate) => {
            
            //If a lookup has been updated since the cache was last refreshed, update the cache
            if(new Date((slmlookupdate.look_up_date||"2000-01-01")) > new Date(cachedSlmLookupdate) || slmlookupdate.look_up_date ==null){
                //console.log("Cache expired or not present getting lookups");
                API.get("colin", `/slmlookups`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((slmlookups) => {
                    if (slmlookups) {
                        var expiration = new Date();
                        expiration.setDate(expiration.getDate()+1);
                        //console.log("expiration: "+expiration);
                        Cache.setItem('slmlookupdate', new Date(), { expires: expiration.getTime() }); 
                        //console.log("retrieved lookups : "+slmlookups);
                        Cache.setItem('slmlookups', slmlookups);
                        this.setState({ slmlookups: slmlookups }, this.synchState);
                        
                                                                       
                    }
                });
            }
            else
            {
             
                const slmlookups= Cache.getItem('slmlookups');
                this.setState({ slmlookups: slmlookups }, this.synchState);
            }

            
        });
        }
        catch{
            console.log("Error getting slmlookups");
        }
    }

    addNewPropertyToSearch(propertyKey) {
        this.setState({ propertyKey: propertyKey });
        let propertyOptions = [...this.state.propertyOptions];
        propertyOptions.push({
            value: propertyKey, label: propertyKey
        });
        this.setState(state => ({ propertyOptions }));
    }

    focusOnQuickLookup(){
        console.log("in focusOnQuickLookup");
        document.getElementById("quickLookup").focus();
    }

    handlePropertyInputChange = event => {
        this.setState(state=>({ propertyKey: event }));
        let propertyOptions = [...this.state.propertyOptions];

        let index = propertyOptions.findIndex(option => option.value === event.value);
        if (index>=0){
            propertyOptions.splice(index, 1);
        }
        propertyOptions.unshift({
            value: event, label: event
        });
        this.setState(state => ({ propertyOptions }));

        this.props.history.push("/properties/" + event.toUpperCase());
    }

    handlePropertyChange = async (selectedProperty) => {
        this.setState(state => ({ selectedProperty: null }));
        let propertyOptions = [...this.state.propertyOptions];
        
        let index = propertyOptions.findIndex(option => option.value === selectedProperty.value);
        console.log(index);
        if (index>=0){
            console.log("Modifying the list");
            propertyOptions.splice(index, 1);
        }
        propertyOptions.unshift(selectedProperty);
        this.setState(state => ({ propertyOptions }));
        


        this.setState(state => ({ propertyKey: selectedProperty.label.toUpperCase() }));
        
        this.props.history.push("/properties/" + selectedProperty.label.toUpperCase());
        
    }


    handleSelectCityScope()
    {
        this.getPropertySearchHistory({ user: this.state.user });  
        this.getUserPermissions({ userName: this.state.user });      
        this.getCityscopeLookups({ date: new Date() });  
        this.setState({selectedApp: "cityscope"});
    }

    handleSelectSLM()
    {
        this.getSLMLookups({ date: new Date() });
        this.setState({selectedApp: "slm"});
    }

    handleSelectCoapiDemo()
    {
        this.setState({selectedApp: "coapidemo"});
    }

    handleAppReset(){
       
        this.setState({selectedApp: ""});
    }

    appSelect(){
        return(
            
            <div className="App container-fluid"> 
            
            <Navbar collapseOnSelect  expand="lg" variant="light" bg="light"  >
            <Navbar.Brand>
                <LinkContainer to="/"><img src='/cotality_logo.png' alt="Logo" className="logo" /></LinkContainer>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
             
                </Nav>

            </Navbar.Collapse>
        </Navbar>

        <br />
        <div className="bg">
                <img src="/../cotality_background_1.png" alt=""/>
                </div>
            <Form>
                <Row>
                <Col sm={2} md={4} lg={3}></Col>
                    <Col sm={2} md={2} lg={2}><LinkContainer to="/properties"><Button variant="danger"  onClick={this.handleSelectCityScope} block>Cityscope</Button></LinkContainer></Col>
                    <Col sm={2} md={2} lg={2}><LinkContainer to="/slmaddresses"><Button variant="danger"  onClick={this.handleSelectSLM}  block>SLM</Button></LinkContainer></Col>
                    {/* <Col sm={2} md={2} lg={2}><LinkContainer to="/coapidemo"><Button variant="danger"  onClick={this.handleSelectCoapiDemo}  block>COAPI Demo</Button></LinkContainer></Col> */}
                </Row>
            </Form>
            
            </div>
            
        );
        
    }



    renderCityscope(childProps)
    {
        const handlers = {
                            QUICK_LOOKUP: this.focusOnQuickLookup
                        };
        return(
            <div className="App container-fluid">
                <HotKeys keyMap={keyMap} handlers={handlers}>
                <div>

                    <Navbar collapseOnSelect expand="lg"  bg="light" variant="light" sticky="top">
                        <Navbar.Brand>
                            <LinkContainer to="/"><img src='/cotality_logo.png' alt="Logo" className="logo" /></LinkContainer>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mr-auto">

                            <LinkContainer to='/properties'><Nav.Link>Properties </Nav.Link></LinkContainer>
                            <LinkContainer to='/leases'><Nav.Link>Tenants </Nav.Link></LinkContainer>
                            <LinkContainer to='/owners'><Nav.Link>Owners</Nav.Link></LinkContainer>
                            <LinkContainer to='/entities'><Nav.Link >Entities</Nav.Link></LinkContainer>
                            <LinkContainer to='/headoffices'><Nav.Link >Head Offices</Nav.Link></LinkContainer>
                            <NavDropdown title="Proofing" id="basic-nav-dropdown">
                            <LinkContainer to='/proofing/WithholdingProofing'><Nav.Link >HOLD Checks</Nav.Link></LinkContainer>
                                <LinkContainer to='/proofing'><Nav.Link >Other Proofing</Nav.Link></LinkContainer>
                                <LinkContainer to='/proofing/ad-hoc'><Nav.Link >Ad-hoc Proofing Queues</Nav.Link></LinkContainer>
                                
                            </NavDropdown>
                            <NavDropdown title="Queues" id="basic-nav-dropdown">
                                <LinkContainer to='/queues/asicsearches'><NavDropdown.Item >ASIC Searches</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/queues/salesheets'><NavDropdown.Item >Sale Sheet Follow Up</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/queues/queries'><NavDropdown.Item >Queries</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/queues/salesfeed'><NavDropdown.Item >RP Sales Feed</NavDropdown.Item></LinkContainer>

                            </NavDropdown>
                            <NavDropdown title="Lookups" id="basic-nav-dropdown">
                                <LinkContainer to='/cityscopes'><NavDropdown.Item >Cityscopes</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/articlecategories'><NavDropdown.Item >Article Categories</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/countries'><NavDropdown.Item >Countries</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/cpirates'><NavDropdown.Item >CPI Rates</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/ausuburbs'><NavDropdown.Item >AU Suburbs</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/nzsuburbs'><NavDropdown.Item >NZ Suburbs</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/positions'><NavDropdown.Item >Positions</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/salutations'><NavDropdown.Item >Salutations</NavDropdown.Item></LinkContainer>
                                <LinkContainer to='/iscompanykeywords'><NavDropdown.Item >Is Company Keywords</NavDropdown.Item></LinkContainer>
                                {this.state.trust_proof && <LinkContainer to='/users'><NavDropdown.Item >Users</NavDropdown.Item></LinkContainer>}

                            </NavDropdown>
                            <LinkContainer to='/mergersubs'><Nav.Link > Mergers &amp; Subs</Nav.Link></LinkContainer>
                            <NavDropdown title="Utilities" id="basic-nav-dropdown">
                                
                            <LinkContainer to='/walkcopy'><Nav.Link > Walk Copy</Nav.Link></LinkContainer>
                            <LinkContainer to='/intropgx'><Nav.Link > Newsletters</Nav.Link></LinkContainer>
                            <LinkContainer to='/mergersubsexport'><Nav.Link > Mergers &amp; Subs Export</Nav.Link></LinkContainer>
                            </NavDropdown>


                        </Nav>
                        </Navbar.Collapse>
                        {config.env !=="prod" && <h2><font color="red">UAT NOT LIVE</font></h2> }
                        <Nav className="justify-content-end" >
                            <Nav.Item>
                                {this.state.isAuthenticated && this.state.user
                                    ? <Nav.Link onClick={this.handleLogout}>Logout</Nav.Link>
                                    : <Nav.Link onClick={this.handleLogin}>Login</Nav.Link>

                                }
                            </Nav.Item>
                        </Nav>


                    </Navbar>

                    {/* <br /> */}
                    <Form>
                        <Row>
                            <Col sm={4} md={4} lg={2}>
                                <Creatable
                                    onCreateOption={this.handlePropertyInputChange}
                                    value={this.state.selectedProperty}
                                    onChange={this.handlePropertyChange}
                                    options={this.state.propertyOptions}
                                    placeholder="Quick Lookup"
                                    tabindex="0"
                                    inputId="quickLookup"
                                    className="quickLookup"
                                />
                            </Col>
                        </Row>
                    </Form>

                    <div>
                        <div>



                            <br />

                            <Routes childProps={childProps} />

                        </div>

                    </div>

                </div>
                </HotKeys>
            </div>
        );
    }


    renderSLM(childProps)
    {
        console.log("In renderSLM");
        
        // Cache.setItem('key', 'value');
        return(
        <div className="App container-fluid"> 
        <div>
            <Navbar collapseOnSelect  expand="lg" variant="dark" bg="dark"  sticky="top" >
                <Navbar.Brand>
                    <LinkContainer to="/"><img src='/cotality_logo_white.png' alt="Logo" className="logo" /></LinkContainer>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
        
                        <LinkContainer to='/slmaddresses'><Nav.Link>Addresses</Nav.Link></LinkContainer>
                        <LinkContainer to='/slmsales'><Nav.Link>Sales</Nav.Link></LinkContainer>
                        <LinkContainer to='/slmleases'><Nav.Link>Leases</Nav.Link></LinkContainer>
                        <NavDropdown title="Lookups" id="basic-nav-dropdown">
                            <LinkContainer to='/slmcategories'><NavDropdown.Item >Categories</NavDropdown.Item></LinkContainer>
                            <LinkContainer to='/slmsuburbs'><NavDropdown.Item >Suburbs Add/Edit</NavDropdown.Item></LinkContainer>
                            <LinkContainer to='/slmrcasuppressionlist'><NavDropdown.Item >RCA Manual Suppressions</NavDropdown.Item></LinkContainer>
                            <LinkContainer to='/iscompanykeywords'><NavDropdown.Item >RCA Keyword Suppressions</NavDropdown.Item></LinkContainer>
                            
                               
                        </NavDropdown>
                        <LinkContainer to='/slmproofingadhoc'><Nav.Link>Ad-hoc Proofing Queues</Nav.Link></LinkContainer>
                        
                                    
                    </Nav>
                    {config.env !=="prod" && <h2><font color="red">UAT NOT LIVE</font></h2> }
                    <Nav className="justify-content-end" >
                        <Nav.Item>
                            {this.state.isAuthenticated && this.state.user
                                ? <Nav.Link onClick={this.handleLogout}>Logout</Nav.Link>
                                : <Nav.Link onClick={this.handleLogin}>Login</Nav.Link>

                            }
                        </Nav.Item>
                    </Nav>

                </Navbar.Collapse>
            </Navbar>

            <br />
            <div>
                <div>
                    <br />
                    <Routes childProps={childProps} />
                </div>

            </div>

        </div>
        </div>
        );
        
    }

    renderCoapiDemo(childProps) {
        console.log("In renderCoapiDemo");
        return (
            <div className="App container-fluid">
                <Routes childProps={childProps} />
            </div>
        )
    }

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            user: this.state.user,
            userPermissions: this.state.userPermissions,
            addNewPropertyToSearch: this.addNewPropertyToSearch,
            handleAppReset: this.handleAppReset,
            sourcecategoryOptions: this.state.sourcecategoryOptions ,
            statuscategoryOptions: this.state.statuscategoryOptions ,
            spaceusecategoryOptions: this.state.spaceusecategoryOptions ,
            broadspaceusecategoryOptions: this.state.broadspaceusecategoryOptions ,
            zoningcategoryOptions: this.state.zoningcategoryOptions ,
            qualitytypecategoryOptions: this.state.qualitytypecategoryOptions ,
            titlebasiscategoryOptions: this.state.titlebasiscategoryOptions ,
            salemethodcategoryOptions: this.state.salemethodcategoryOptions ,
            saledescribercategoryOptions: this.state.saledescribercategoryOptions ,
            incomebasiscategoryOptions: this.state.incomebasiscategoryOptions ,
            areabasiscategoryOptions: this.state.areabasiscategoryOptions ,
            carspacecategoryOptions: this.state.carspacecategoryOptions ,
            saleTypes: this.state.saleTypes,
            leasemethodcategoryOptions: this.state.leasemethodcategoryOptions,
            leasestatuscategoryOptions: this.state.leasestatuscategoryOptions,            
            leaselevelcategoryOptions: this.state.leaselevelcategoryOptions ,
            leaseoutgoingscategoryOptions: this.state.leaseoutgoingscategoryOptions ,
            rentperannumbasiscategoryOptions: this.state.rentperannumbasiscategoryOptions ,
            rentpersqmbasiscategoryOptions: this.state.rentpersqmbasiscategoryOptions,
            leaselreviewbasiscategoryOptions: this.state.leaselreviewbasiscategoryOptions,
            leaseTypes: this.state.leaseTypes,
            streetTypes: this.state.streetTypes,
            unitTypes: this.state.unitTypes,
            categoryGroups: this.state.categoryGroups,
            subRegionOptions: this.state.subRegionOptions,

            liftOperatorOptions: this.state.liftOperatorOptions,
            articleCategories: this.state.articleCategories,
            fileTypes: this.state.fileTypes,
            withholdingReasons: this.state.withholdingReasons,
            buildingGradeSourceOptions: this.state.buildingGradeSourceOptions,
            buildingGradeOptions: this.state.buildingGradeOptions,
            classificationOptions: this.state.classificationOptions,
            leaseClassificationOptions: this.state.leaseClassificationOptions,
            reviewTypeOptions: this.state.reviewTypeOptions,
            countryOptions: this.state.countryOptions,
            countryCodeOptions: this.state.countryCodeOptions,
            salutationOptions: this.state.salutationOptions,
            positionOptions: this.state.positionOptions,
            firstNames: this.state.firstNames



        };

        if (this.state.isAuthenticated && this.state.user)
        {
            if (!this.state.selectedApp){
                return(this.appSelect(childProps));
            }
            if(this.state.selectedApp == "cityscope")
            {
                return(this.renderCityscope(childProps));
            }
            if(this.state.selectedApp == "slm")
            {
                
                return(this.renderSLM(childProps));
            }
            if(this.state.selectedApp == "coapidemo")
            {
                return(this.renderCoapiDemo(childProps))
            }

        }
        else{
            return(
<div className="App container-fluid"> 
<div className="bg">
                <img src="/../cotality_background_2.png" alt=""/>
                </div>
<Navbar collapseOnSelect  expand="lg" variant="light" bg="light"  >
                <Navbar.Brand>
                    <LinkContainer to="/"><img src='/cotality_logo.png' alt="Logo" className="logo" /></LinkContainer>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        
                    
                    </Nav>
                    <Nav className="justify-content-end" >
                        <Nav.Item>
                            {this.state.isAuthenticated && this.state.user
                                ? <Nav.Link onClick={this.handleLogout}>Logout</Nav.Link>
                                : <Nav.Link onClick={this.handleLogin}>Login</Nav.Link>

                            }
                        </Nav.Item>
                    </Nav>

                </Navbar.Collapse>
            </Navbar>
        <br/>
        <h1>Please log in</h1>
        </div>
            );
        }
        
    }


}

export default withRouter(App);
